/**
 * Zentrale Storage-Key-Listen für Auth-Aufräumarbeiten.
 *
 * Die beiden Listen divergieren BEWUSST:
 *
 * - AUTH_SESSION_STORAGE_KEYS: wird beim erzwungenen Auth-Reset
 *   (401/UNAUTHENTICATED im ApolloWrapper) geräumt. Bewusst NUR die reine
 *   Session — der Buchungskontext (booker, attendeeId, bookingData, course)
 *   und die LogRocket-ID (_lr_id_) bleiben unangetastet, damit eine laufende
 *   Buchung den Session-Ablauf überlebt und der Re-Login via fromUrl zurück
 *   zur BookingSummary führt.
 *
 * - LOGOUT_STORAGE_KEYS: regulärer, vom Nutzer ausgelöster Logout
 *   (src/views/Logout/Logout.tsx). Räumt zusätzlich den kompletten
 *   Buchungskontext — auf gemeinsam genutzten Geräten darf nach dem
 *   Abmelden nichts Personenbezogenes zurückbleiben.
 */

/** Reine Session-/Auth-Keys — der 401-Cleanup räumt ausschließlich diese. */
export const AUTH_SESSION_STORAGE_KEYS = ["accessToken", "refreshToken", "loggedInUser", "loggedInUserEmail"]

/**
 * Vollständige Aufräumliste für den regulären Logout: Session + Buchungskontext.
 * "loginFromUrl" (LOGIN_FROM_URL_STORAGE_KEY aus containers/login/loginFromUrl.ts):
 * ein liegengebliebenes Rücksprungziel darf den nächsten Login auf diesem Gerät
 * nicht umleiten. Beim 401-Reset bleibt es bewusst erhalten (Re-Login-Rückkehr).
 */
export const LOGOUT_STORAGE_KEYS = [...AUTH_SESSION_STORAGE_KEYS, "booker", "attendeeId", "bookingData", "course", "_lr_id_", "loginFromUrl"]
